import type { useProSearch } from '@application/utils';
import type { ProfessionalTypeEnum } from '@gql/graphql';
import type { SelectOption } from '@presentation/components';

export type ProSearchFieldType = 'location' | 'proType' | 'search';

export type ProSearchField =
  | {
      type: 'location';
      value?: SelectOption<string>; // Google places: place id
    }
  | {
      type: 'proType';
      value?: SelectOption<ProfessionalTypeEnum>;
    }
  | {
      type: 'search';
      value?: SelectOption<number>;
    };

export interface ProSearchValues {
  location?: string;
  proType?: ProfessionalTypeEnum;
  search?: number;
}

export interface ProSearchInputValues {
  location?: string;
  search?: string;
}

export type ProSearchInputField = {
  type: keyof ProSearchInputValues;
  value?: string;
};

export interface ProSearchOptions {
  proType: SelectOption<ProfessionalTypeEnum>[];
  search?: SelectOption<number>[];
  location?: SelectOption<string>[];
}

export interface ProSearchParams {
  initialValues?: ProSearchValues;
  setSearchOnUpdate?: boolean;
  onSubmit?: (values: ProSearchValues) => void;
}

export type ProSearchData = ReturnType<typeof useProSearch>;
